export const computeStylesForSelectedId = () => {
  return {
    borderColor: "#005D49",
    backgroundColor: "#E6F3F0",
    borderWidth: "1px",
    fontWeight: "bold",
    color: "#005D49",
    boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
  };
};
